import * as Redux from 'redux'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Types from './types'
import * as Utils from './utils'

export interface StateChangeActionObject extends Redux.Action {
  change: Types.StateChange,
}
export type StateChangeAction = (event: string, change: Types.StateChange) => StateChangeActionObject
export const stateChange: StateChangeAction =
  (event: string, change: Types.StateChange): StateChangeActionObject =>
  ({type: Utils.updateStatusConstant(event), change})

export  type UpdateStatusAction = (community: string, stateChange: Types.StateChange) => Request.RequestAction

export interface FilterActionObject extends Redux.Action {
  filter: Types.Filter,
}

export type FilterSelector = (state: ApplicationState) => Types.Filter
export type DateSelector = (state: ApplicationState) => string

export type FilterAction = (event: string, filter: Types.Filter) => FilterActionObject
export const applyFilter: FilterAction =
  (event: string, filter: Types.Filter): FilterActionObject =>
  ({type: Utils.filterStatusConstant(event), filter})

export type FilteredFetcher = (communityIdentifier: string, filter: Types.Filter) => Request.RequestAction
export type DateFetcher = (communityIdentifier: string, filterDate: string) => Request.RequestAction

export const filteredFetchAction = (action: string, url: string): FilteredFetcher =>
  (communityIdentifier: string, filter: Types.Filter) =>
  Request.requestActionCreator(action)
  ({url: `${url}/${communityIdentifier}?${Utils.asQueryString(filter)}`, method: 'GET'})

export const filteredWithoutCommunityFetchAction = (action: string, url: string): FilteredFetcher =>
  (communityIdentifier: string, filter: Types.Filter) =>
  Request.requestActionCreator(action)
  ({url: `${url}?${Utils.asQueryString(filter)}`, method: 'GET'})

export type FilteredDateFetcher = (communityIdentifier: string, filterDate: string) => Request.RequestAction
export const filteredDateFetchAction = (action: string, url: string): FilteredDateFetcher =>
  (communityIdentifier: string, filterDate: string) =>
  Request.requestActionCreator(action)
  ({url: `${url}/${communityIdentifier}/date/${filterDate}?status=active`, method: 'GET'})

export const filteredDateFetchActionInclusive = (action: string, url: string): FilteredDateFetcher =>
 (communityIdentifier: string, filterDate: string) =>
 Request.requestActionCreator(action)
  ({url: `${url}/${communityIdentifier}/date/${filterDate}`, method: 'GET'})



// WEBPACK FOOTER //
// ./src/components/is_active/actions.ts